import React from 'react';
import { KeyVal, Input } from 'equasion-lib';
import WarehouseProductDisplay from '@/lib/shared-coms/WarehouseProductDisplay';
import './ProductInLocation.scss';

const ProductInLocation = ({
  quantity,
  lot,
  product = {},
  newQuantity,
  setNewQuantity,
  actionType = 'Move'
}) => {
  return (
    <div className="product-in-location">
      <WarehouseProductDisplay product={product} />
      <KeyVal
        items={[
          {
            key: 'Lot #',
            value: lot
          },
          {
            key: 'QTY',
            value: quantity
          }
        ].filter(Boolean)}
      />
      {!!setNewQuantity && (
        <Input
          form={false}
          inputType="number"
          defaultValue={0}
          value={newQuantity}
          onChange={({ value }) => setNewQuantity(value)}
          label={`Enter Quantity To ${actionType}`}
        />
      )}
    </div>
  );
};

export default ProductInLocation;
